<div class="item" (click)="onClick()" *transloco="let t; read:'permit.prepare'">
    <div class="item__content">
        <div class="item__content__company-name" [innerHTML]="item.companyName"></div>
        <div class="item__content__workplace" [innerHTML]="fullPermitName(item)"></div>
        <div class="item__content__emergency-location" [innerHTML]="item.emergencyLocation"></div>
        <div class="item__content__prepared-by" [innerHTML]="t('preparedBy', { name: item.preparedByName})"></div>
    </div>
    <div class="item__arrow"></div>
</div>
